export enum sideBarPermission {
    dashboard = 'Dashboard',
    eventList = 'Event List',
    invoiceList = 'Invoice List',
    participantList = 'Participant List',
    waitingList = 'Waiting List',
    itemSales = 'Item Sales',
    reports = 'Reports',
    walletTransaction = 'Wallet Transaction',
    bulkUpload = 'Bulk Upload',
    discoveryBanner = 'Discovery Banner',
    sportsCategory = 'Sports Category',
    currency = 'Currency',
    managePartners = 'Manage Partners',
    globalDisclaimer = 'Global Disclaimer',
    manageCountries = 'Manage Countries',
    manageArea = 'Manage Area',
    manageTShirtSize = 'Manage TShirt-Size',
    eventMaster = 'Event Master',
    raceKit = 'Race Kit',
    couponManagement = 'Coupon Management',
    category = 'Category',
    itemList = 'Item List',
    deliveryCharge = 'Delivery Charge',
    colorManagement = 'Color Management',
    sizeManagement = 'Size Management',
    admins = 'Admins',
    customerList = 'Customer List',
    agent = 'Agent',
    volunteer = "Volunteer",
    activityLog = 'Activity Log',
    notification = 'Notification',
    vendingMachineReports = 'Vending Machine Reports',
    vendingMachine = 'Vending Machine'
  }
  export enum sideBarpermission {
    dashboard="dashboard",
    executive_summary="executive_summary",
    registration="registration",
    shop="shop",
    booth="booth",
    event_management="event_management",
    event_list="event_list",
    transactions="transactions",
    group_registration="group_registration",
    participant_list="participant_list",
    reports="reports",
    invoice_list="invoice_list",
    coupon="coupon"
  }